import { combineReducers } from '@reduxjs/toolkit';
import lessonTaskDataReducer, { dataActions } from './data';
import { feedbackActions } from './feedback';
import lessonTaskSelectors from './selectors';
import lessonTaskSessionReducer, { sessionActions } from './session';

export * from './data';
export * from './feedback';
export * from './session';
export { lessonTaskSelectors };

export const lessonTaskActions = {
  ...dataActions,
  ...sessionActions,
  ...feedbackActions
};

const lessonTaskReducer = combineReducers({
  data: lessonTaskDataReducer,
  session: lessonTaskSessionReducer
});

export default lessonTaskReducer;
